import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import { isEmpty } from 'lodash';


import {
    FormControl,
    FormLabel,
    FormControlLabel,
    Radio,
    RadioGroup,
} from '@mui/material';

import CircleIcon from '@mui/icons-material/Circle';

import { useStyles } from './styles';
 
function RadioSelect (props) {

    const {
        name ='selection',
        title = 'Radio Selection',
        widget =  {},
        widgetTheme = {},
        value ='value1',
        options = [
            { value: 'option1', label: 'Option 1' },
            { value: 'option2', label: 'Option 2' },
            { value: 'option3', label: 'Option 3' },
        ],
        className = {},
        onChange = () => {},
    } = props;
   
    const classes = useStyles({
        widget,
        widgetTheme,
    });
    

    function renderOptions () {
        if (isEmpty(options)) {
            return (
                <React.Fragment></React.Fragment>
            );
        }

        return options.map((item)  => {
            return (
                <FormControlLabel
                    key={item.value}
                    className={classes.radioItem}
                    value={item.value}
                    control={<Radio
                        icon={<div className={classes.unselected}></div>}
                        checkedIcon={<div className={classes.selected}>
                            <CircleIcon />
                        </div>}
                    />}
                    label={item.label}
                    />
            );
        });
    }

    return (
        <FormControl
            className={classNames([className, classes.container])}
            id={`radio-select-${name}`}
        >
            <FormLabel className={"ecal-input-label"}>{title}</FormLabel>
            <RadioGroup
                className={classes.groupRoot}
                name={`radio-group-${name}`}
                value={value ?? ''}
                onChange={(e) => onChange({ value: e.target.value })}
            >
                { renderOptions() }
            </RadioGroup>
        </FormControl>
    );
}

RadioSelect.propTypes = {
    name: PropTypes.string,
    title: PropTypes.string,
    widget: PropTypes.any,
    widgetTheme: PropTypes.any,
    value: PropTypes.string,
    options: PropTypes.array,
    className: PropTypes.any,
    onChange: PropTypes.func,
};

export default RadioSelect;
